import { ChangeDetectionStrategy, Component, OnDestroy, signal } from '@angular/core';
import { IconEnum } from './shared/models/assets.model';
import { Subscription } from 'rxjs';
import { FeatureService } from './shared/services/feature.service';
import { FeatureEnum } from './shared/models/feature.model';
import { AssetsService } from './shared/services/assets.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.html',
	standalone: false,
	styleUrl: './app.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnDestroy {
	private subscriptions = new Subscription();
	protected readonly title = signal('connect');
	protected readonly ICONS = IconEnum;
	public showNote = signal(false);
	public showCallbackOnCallNote = signal(false);
	public showFeedback = signal(false);
	public showError = signal(false);
	/** The customer-service SIP order link page. */
	public showSipOrder = signal(false);
	public isPrintMode = signal(new URLSearchParams(location.search).has('print'));


	constructor(
		private assetsService: AssetsService,
		private featureService: FeatureService,
	) {
		this.initSubscriptions();
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	triggerPrint() {
		window.print();
	}

	private initSubscriptions() {
		this.subscriptions.add(
			this.featureService.features$.subscribe((features) => {
				this.showNote.set(features.some((f) => f === FeatureEnum.NOTE));
				this.showCallbackOnCallNote.set(
					features.some((f) => f === FeatureEnum.CALLBACK_ON_CALLNOTE),
				);
				this.showFeedback.set(features.some((f) => f === FeatureEnum.FEEDBACK));
				this.showError.set(features.some((f) => f === FeatureEnum.ERROR));
				this.showSipOrder.set(features.some((f) => f === FeatureEnum.SIP_ORDER));
			}),
		);
	}
}
